import React, { useEffect, useState } from 'react';
import styles from './BackButton.module.scss';

interface BackButtonProps {
  href: string;
  altText?: string;
  skeleton?: string;
  disabled?: boolean;
  active?: boolean;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
                                                 href,
                                                 altText = 'Back',
                                                 skeleton = '',
                                                 disabled = false,
                                                 active = false,
                                                 className = ''
                                               }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // Проверка, меньше ли ширина 1024px
    };

    handleResize(); // Вызвать функцию один раз при монтировании
    window.addEventListener('resize', handleResize); // Добавить обработчик события изменения размера

    return () => {
      window.removeEventListener('resize', handleResize); // Удалить обработчик при размонтировании
    };
  }, []);
  const buttonClasses = [
    styles.button,
    skeleton ? styles.skeleton : '',
    disabled ? styles.disabled : '',
    active ? styles.active : '',
    className
  ].filter(Boolean).join(' ');

  const logoClasses = [
    styles.eutiroksCon,
    skeleton ? styles.skeleton : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={styles.topContainer}>
      <a
        href={disabled ? undefined : href}
        className={buttonClasses}
        aria-label={altText}
        aria-disabled={disabled}
      >
        <div className={styles.icon}></div>
      </a>
      {!isMobile && (<div className={logoClasses}>
        <div className={styles.img}></div>
      </div>)}

    </div>

  );
};

export default BackButton;